import { optimizeImage, useOptimizeContext } from "ui-tools"

const LOGO_TARGET_HEIGHT = 50

export const useOptimizedCompanyLogo = () => {
  const context = useOptimizeContext()

  const optimizeLogo = (logoUrl: string) => {
    const { app, optimizeUrl } = context || {}
    if (!app || !optimizeUrl) return logoUrl

    const height = app.heights.find((height) => height >= LOGO_TARGET_HEIGHT)
    return optimizeImage({ app, optimizeUrl, src: logoUrl, height })
  }

  return { optimizeLogo }
}
